module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-app-img-bg js-app-img u-absolute u-fit",
    class: [_vm.isLoading ? 'is-loading' : '', !_vm.fit ? 'is-not-fitted' : ''],
    style: (_vm.style)
  }, [_c('img', {
    staticClass: "js-loader-img-hidden u-opacity--0",
    attrs: {
      "src": _vm.src
    },
    on: {
      "load": _vm._onLoad
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-app-img-bg__loader-container u-absolute u-pos-tl u-index--2 u-fit u-bg--gray-darkest u-opacity--5"
  }, [_c('div', {
    staticClass: "c-app-img-bg__loader u-absolute u-overflow-h"
  }, [_c('img', {
    staticClass: "c-app-img-bg__loader__img js-loader-img u-absolute u-pos-tl",
    attrs: {
      "src": require("../../../assets/loader/loader-sprite-map.png"),
      "alt": "Loader"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-768a4f34"}!./src/scripts/components/app-img-bg/template.html
// module id = 936
// module chunks = 0